
export const MEDIA_FIELDS = [
    { key: 'name', label: "name",  },
    { key: 'amount', label: "amount", type: "number" },
    { key: 'salesAgentName', label: "Commission Type", type: "fixed-select", options: [{label: "Sales commission", value: "sales commission"}, {label: "Account manager", value: "account manager"}, {label: "working mediator", value: "working mediator"}] },
    { key: 'startDate', label: "start Date", type: "date"},

]





const FIELDS = [
    ...MEDIA_FIELDS,
]

export default FIELDS


